import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { Pagination } from '../components/Pagination';
import { Loading } from '../components/Loading';
import moment from 'moment';
import dateformat from 'dateformat';
import NotificationContentItem from './NotificationContentItem';
import { NOTIFICATION_SERVICE } from '../../lib/const';
import Api from 'utils/api/Api';
import { closeNotification } from './ducks/notificationModal';


export const NotificationList = ()=>{
    const dispatch = useDispatch();
    const [page, setPage] = useState(0);

    const { data:notificationList, isFetching,  isSuccess } = useQuery({
        queryKey:['notification/list', page],
        queryFn:()=>Api.get(`/api/notification/list?page=${page}`),
        refetchOnMount:'always',
        placeholderData:keepPreviousData,
    });   

    const renderList = ()=>{  
        if(notificationList?.data?.list.length<=0){
            if(notificationList?.data?.loading)return null;
            return <tr><td colSpan="4" className="no_data"><p>알림이 없습니다.</p></td></tr>;
        }
        
        const today = dateformat(moment(), 'yyyy-mm-dd');
        return notificationList?.data?.list.map((notification, key) => {
            let num = notificationList?.data?.page*5+key+1
            
            return (
                <tr key={notification.id} className={`notice ${notification.important==='Y'?'important':''}`} >
                    <td>{num}</td>

                    <td>{notification.createdAt && dateformat(notification.createdAt.substring(0, 20), (today === notification.createdAt.substring(0, 10)) ? 'HH:MM:ss' : 'yyyy.mm.dd')}</td>
                    <td className="desc">
                        <NotificationContentItem notification={notification} />
                    </td>
                    <td>{NOTIFICATION_SERVICE[notification.service]}</td>
                </tr>
            )
        });
    }

    return (
        <div className="modal user_notice" id="modal_notice">
            <div className="modal_cont">
                <h3><span className="icon08">알림</span></h3>
                <button type="button" className="btn_close modal_close" onClick={()=>dispatch( closeNotification())}><span></span><span></span></button>
                <div className="tbl_wrap">
                    <table>
                        <thead>
                            <tr>
                                <th>번호</th>
                                <th>날짜</th>
                                <th>내용</th>
                                <th>항목</th>
                            </tr>
                        </thead>
                        <tbody>
                            {renderList()}
                        </tbody>
                    </table>
                    <Loading overlay={true} active={isFetching} />
                </div>
                {isSuccess && <Pagination page={notificationList?.data?.page} totalPage={notificationList?.data?.totalPages} gotoPage={(num)=>setPage(num)} /> }
            </div>
        </div>
    );
}